import { useEffect, useState } from "react";
import { Atom, EventBus } from "lib/event-bus";

export function useSubscribe<I, Msg>(source: EventBus<Msg>, initial: I): I | Msg {
  const initialValue = source instanceof Atom && source.value?.ok ? source.value?.ok : initial;
  const [value, setValue] = useState<I | Msg>(initialValue);
  useEffect(() => source.subscribe(setValue), [source]);
  return value;
}

export function useAtomSubscribe<T>(source: Atom<T>): T {
  const [value, setValue] = useState(source.value);
  useEffect(() => source.subscribe(value => setValue(value)), [source]);
  return value;
}
